module.exports = __webpack_public_path__ + "media/images/wait_icon-4b69c4879c30b552b7c7c856d8031ccd.svg";